/*
 * BrandStencil ROI calculator
 *
 * Handle the ROI calculator form
 */

import calculateROI from '../utils/calculate-roi';

/*
 * Extend the number object so we can define formatting
 *
 */
Number.prototype.format = function (n, x) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

// These are all the possible outcomes
const roiCalculatorOutcomes = {
  good: {
    heading: 'Great News!',
    figures: ['costSavingYear1', 'costSavingYear2', 'timeSavingYear1'],
    callToAction: {
      url: '/free-trial',
      text: 'Why not sign up for a free trial now?',
    },
  },
  medium: {
    heading: 'Great News!',
    figures: ['costSavingYear2', 'timeSavingYear1'],
    callToAction: {
      url: '/free-trial',
      text: 'Why not sign up for a free trial now?',
    },
  },
  bad: {
    heading: 'Let’s take a look…',
    figures: ['costSavingText', 'timeSavingYear1'],
    callToAction: {
      url: '/contact-us',
      text: 'Get in touch now to start saving',
    },
  },
};

class BrandStencilROICalculator {
  constructor() {
    this.rOICalculator = document.querySelector('.js-roi-calculator');
    this.BREAKPOINT = 'md';

    if (this.rOICalculator) {
      this.submitButton = this.rOICalculator.querySelector(
        '.js-roi-calculator-submit'
      );

      this.submitButton.addEventListener(
        'click',
        this.processROIForm.bind(this)
      );
    }
  }

  processROIForm() {
    // Get form elements
    const artworkCountInput = document.getElementById('artwork_count');
    const artworkCountErrors = document.getElementById('artwork_count_errors');
    const templateCountInput = document.getElementById('template_count');
    const templateCountErrors = document.getElementById(
      'template_count_errors'
    );
    const tooManyTemplatesWrapper = document.querySelector(
      '.js-too-many-templates'
    );

    // Get output elements
    const outputs = {
      costSavingText: document.querySelector('.js-saving-cost-text'),
      costSavingYear1: document.querySelector('.js-saving-cost-year1'),
      costSavingYear2: document.querySelector('.js-saving-cost-year2'),
      timeSavingYear1: document.querySelector('.js-saving-time-year1'),
    };

    // Get values needed for calculation
    let artworkCount = artworkCountInput.value;
    const frequency = this.rOICalculator.querySelector(
      '[name="frequency"]:checked'
    ).value;
    const templateCount = templateCountInput.value;

    // Hide any errors
    artworkCountInput.classList.remove('error');
    artworkCountErrors.classList.add('hidden');
    templateCountInput.classList.remove('error');
    templateCountErrors.classList.add('hidden');

    // Check we have values for all required inputs, show errors if not
    if (artworkCount === '' || templateCount === '') {
      if (artworkCount === '') {
        artworkCountInput.classList.add('error');
        artworkCountErrors.classList.remove('hidden');
      }

      if (templateCount === '') {
        templateCountInput.classList.add('error');
        templateCountErrors.classList.remove('hidden');
      }

      return;
    }

    if (templateCount > 20) {
      tooManyTemplatesWrapper.classList.remove('hidden');

      if (!document.querySelector('#template_checkbox:checked')) {
        return;
      }
    } else {
      tooManyTemplatesWrapper.classList.add('hidden');
    }

    // Multiply the monthly artwork count by 12 to make it yearly
    if (frequency === 'month') {
      artworkCount = artworkCount * 12;
    }

    const [costSavingYear1, timeSavingYear1] = calculateROI(
      artworkCount,
      templateCount,
      12
    );
    const [costSavingYear2] = calculateROI(artworkCount, 0, 12);

    // Populate the output figures
    outputs.costSavingYear1.innerHTML = `<span class="text-2xl big-bold">£${costSavingYear1.format()}</span> in Year 1`;
    outputs.costSavingYear2.innerHTML = `<span class="text-2xl big-bold">£${costSavingYear2.format()}</span> in Year 2`;
    outputs.timeSavingYear1.innerHTML = `<span class="text-2xl big-bold">${timeSavingYear1.format()}</span> hours every year`;

    // If there is a cost saving in year 1
    if (costSavingYear1 > 0) {
      this.outcome = roiCalculatorOutcomes.good;
      // If there is a cost saving in year 2, but not in year 1
    } else if (costSavingYear2 > 0) {
      this.outcome = roiCalculatorOutcomes.medium;
      // If there is no cost saving in years 1 or 2
    } else {
      this.outcome = roiCalculatorOutcomes.bad;
    }

    this.populateOutput(this.outcome, outputs);
  }

  populateOutput({ heading, figures, callToAction }, outputs) {
    const outputElement = document.querySelector('.js-roi-calculator-output');
    const outputHeading = document.querySelector(
      '.js-roi-calculator-output-heading'
    );
    const outputCallToAction = document.querySelector(
      '.js-roi-calculator-output-cta'
    );

    // Loop through output elements
    for (var output in outputs) {
      // If it's in the list of figures to output, show it
      if (figures.indexOf(output) !== -1) {
        outputs[output].classList.remove('hidden');
        // Otherwise, hide it
      } else {
        outputs[output].classList.add('hidden');
      }
    }

    outputHeading.innerHTML = heading;
    outputCallToAction.href = callToAction.url;
    outputCallToAction.innerHTML = callToAction.text;

    // Show the output
    outputElement.classList.remove('hidden');

    if (Framework.windowWidth.lt(this.BREAKPOINT)) {
      outputElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

export default BrandStencilROICalculator;
